import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import calcite from '../../assets/images/products/calcite.jpeg';
import calciumCarbonate from '../../assets/images/products/calcium-carbonate.jpg';
import calciumHydroxide from '../../assets/images/products/calcium-hydroxide.jpg';
import calciumOxide from '../../assets/images/products/calcium-oxide.jpg';
import dolomite from '../../assets/images/products/dolomite.jpeg';
import limeStone from '../../assets/images/products/lime-stone.jpg';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import HandshakeIcon from '@mui/icons-material/Handshake';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import Groups2Icon from '@mui/icons-material/Groups2';
import PendingActionsIcon from '@mui/icons-material/PendingActions';


const Label = styled('span')({
    // backgroundColor:'green',
    color: '#7f6001'
    // maxWidth: '50%',
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // flexDirection: 'column',
    // position: 'relative',
    // zIndex: 2
  });

const ChooseUs = () => {
  const { t, i18n } = useTranslation();
  return (
    <div>
    <h2 style={{color: 'rgb(154,74,32)'}}>{t('whyChooseUs')}</h2>
      <Box sx={{display:'flex', justifyContent: 'flex-start', flexWrap:'wrap', gap: '20px', marginTop: '30px', padding: '10px 50px'}}>
      <div style={{display: 'flex', gap: '10px', alignItems:'center'}}>
        <WorkspacePremiumIcon />
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
            <Label>{t('premiumProductQuality')}</Label>
            <p style={{margin: '0px', textAlign: 'start', color: '#1f3864'}}>{t('premiumProductQualityDesc')}</p>
        </div>
      </div>

      <div style={{display: 'flex', gap: '10px', alignItems:'center'}}>
        <BusinessCenterIcon />
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
            <Label>{t('effectivePackaging')}</Label>
            <p style={{margin: '0px', textAlign: 'start', color: '#1f3864'}}>{t('effectivePackagingDesc')}</p>
        </div>
      </div>

      <div style={{display: 'flex', gap: '10px', alignItems:'center'}}>
        <TravelExploreIcon />
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
            <Label>{t('wideDistributionNetwork')}</Label>
            <p style={{margin: '0px', textAlign: 'start', color: '#1f3864'}}>{t('wideDistributionNetworkDesc')}</p>
        </div>
      </div>

      <div style={{display: 'flex', gap: '10px', alignItems:'center'}}>
        <Groups2Icon />
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
            <Label>{t('customizedServices')}</Label>
            <p style={{margin: '0px', textAlign: 'start', color: '#1f3864'}}>{t('customizedServicesDesc')}</p>
        </div>
      </div>

      <div style={{display: 'flex', gap: '10px', alignItems:'center'}}>
        <HeadsetMicIcon />
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
            <Label>{t('extensiveCommunicationLines')}</Label>
            <p style={{margin: '0px', textAlign: 'start', color: '#1f3864'}}>{t('extensiveCommunicationLinesDesc')}</p>
        </div>
      </div>

      <div style={{display: 'flex', gap: '10px', alignItems:'center'}}>
        <SettingsSuggestIcon />
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
            <Label>{t('afterSalesService')}</Label>
            <p style={{margin: '0px', textAlign: 'start', color: '#1f3864'}}>{t('afterSalesServiceDesc')}</p>
        </div>
      </div>

      <div style={{display: 'flex', gap: '10px', alignItems:'center'}}>
        <PendingActionsIcon />
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
            <Label>{t('adherenceToDeliveryDatesAndSchedules')}</Label>
            <p style={{margin: '0px', textAlign: 'start', color: '#1f3864'}}>{t('adherenceToDeliveryDatesAndSchedulesDesc')}</p>
        </div>
      </div>

      <div style={{display: 'flex', gap: '10px', alignItems:'center'}}>
        <HandshakeIcon />
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
            <Label>{t('ethicalBusinessApproach')}</Label>
            <p style={{margin: '0px', textAlign: 'start', color: '#1f3864'}}>{t('ethicalBusinessApproachDesc')}</p>
        </div>
      </div>

    </Box>
    </div>
  );
};

export default ChooseUs;
